import React from 'react';
import Register from '../../components/Register/Register';
import Header from '../../components/Header/Header';

const RegisterPage: React.FC = () => {
	return (
		<div>
			<Header>{''}</Header>
			<Register />
		</div>
	);
};

export default RegisterPage;
